export const CONFIRM_DIALOG_OPEN = 'CONFIRM_DIALOG_OPEN'
export const CONFIRM_DIALOG_CLOSE = 'CONFIRM_DIALOG_CLOSE'



// WEBPACK FOOTER //
// ./src/types/actions/confirm-dialog.js